<template>
  <aside class="org-settings-nav">
    <OrgSettingsHubPanel
      :search="search"
      :categories="categories"
      :active-id="activeId"
      variant="page"
      @update:search="$emit('update:search', $event)"
      @select="$emit('select', $event)"
    />
  </aside>
</template>

<script>
import OrgSettingsHubPanel from "@/components/MasterSettings/OrganizationSettings/OrgSettingsHubPanel.vue";

export default {
  name: "OrganizationSettingsCategoryNav",
  components: { OrgSettingsHubPanel },
  props: {
    search: { type: String, default: "" },
    categories: { type: Array, default: () => [] },
    activeId: { type: String, default: "" },
  },
  emits: ["update:search", "select"],
};
</script>
